<template>

	<div class="row">

		<div class="col-md-12">

			<h2 v-translate>Histórico de Medicações</h2>

			<div class="table-responsive">

				<table class="table table-bordered table-striped table-condensed flip-content">

					<thead class="flip-content">

						<tr>

							<th class="col-time bg-gray align-middle">
								<i class="fa fa-clock-o" aria-hidden="true"></i>
								<span v-translate>Horário programado</span>
							</th>

							<th class="col-time bg-gray align-middle">
								<i class="fa fa-clock-o" aria-hidden="true"></i>
								<span v-translate>Horário ministrado</span>
							</th>

							<th class="bg-gray align-middle">
								<i class="fa fa-graduation-cap" aria-hidden="true"></i>
								<span v-translate>Ministrada por</span>
							</th>

							<th class="bg-gray align-middle">
								<i class="fa fa-user" aria-hidden="true"></i>
								<span v-translate>Aluno</span>
							</th>

							<th class="bg-gray align-middle">
								<i class="fa fa-medkit" aria-hidden="true"></i>
								<span v-translate>Medicação e Dosagem</span>
							</th>

							<th class="bg-gray align-middle">
								<i class="fa fa-heartbeat" aria-hidden="true"></i>
								<span v-translate>Motivo</span>
							</th>

						</tr>

					</thead>

					<tbody v-show="historyList.list.length">

						<tr v-for="(medicine, index) in historyList.list">

							<td class="prog align-middle">

								<!-- <strong>{{ medicine.reject }}</strong> -->

								<i v-if="medicine.medicinesTaken" class="fa fa-check font-green" aria-hidden="true"></i>
								<i v-if="medicine.rejectionReason" class="fa fa-ban font-red" aria-hidden="true"></i>

								{{ medicine.hour | date('HH:mm', true) }}

								<button type="button" class="btn default btn-xs" @click="cancelRejectionMedicine(medicine.id)" v-if="medicine.rejectionReason" v-translate>
									Cancelar Rejeição
								</button>

							</td>

							<td class="align-middle">

								<span v-if="medicine.medicinesTaken">
									{{ medicine.medicinesTaken[0].time | date('HH:mm', true) }}
								</span>

								<span v-if="medicine.rejectionReason">-</span>

							</td>

							<td class="align-middle">

								<span v-if="medicine.medicinesTaken">

									<span v-if="!medicine.medicinesTaken[0].user" v-translate>Não informado</span>
									<span v-if="medicine.medicinesTaken[0].user">{{ medicine.medicinesTaken[0].user.name }}</span>

								</span>

								<span v-if="medicine.rejectionReason">

									<strong class="text-danger" v-translate>Rejeitado</strong>

									<small class="display-block m-t-5">
										<span v-translate>Motivo:</span>
										{{ medicine.rejectionReason || '-' }}
									</small>

								</span>

							</td>

							<td class="align-middle">

								<img width="25px" height="25px" :src="medicine.student.photoURL" class="img-circle">
								<span>{{ medicine.student.name }}</span></br>

								<small class="font-grey-cascade display-block m-t-5">
									<span v-translate>Solicitado por</span>
									{{ medicine.responsible.name }}
								</small>

							</td>

							<td class="text-center align-middle">

								<span>{{ medicine.medicine }} - {{ medicine.dosage }}</span><br>

								<a class="btn btn-link btn-xs" target="_blank" :href="medicine.medicalPrescriptionURL" v-translate>
									Ver receita
								</a>

							</td>

							<td class="text-center align-middle">
								{{ medicine.treatment }}
							</td>

						</tr>

					</tbody>

					<tfoot v-show="!historyList.list.length">
						<tr>
							<td colspan="6" v-translate>Nenhum histórico de mediação na data informada</td>
						</tr>
					</tfoot>

				</table>

			</div>

		</div>

	</div>

</template>

<script>

	import MedicineHistory from './';
	export default MedicineHistory;

</script>

<style lang="scss" scoped>

	th {
		text-align: center;
		color: #fff;
		background-color: #bfcad1;
	}

	td {
		text-align: center;
	}

	h2 {
		font-size: 20px;
	}

	.col-time {
		width: 145px;
	}

</style>



// WEBPACK FOOTER //
// medicine-history.vue?bd4251b4